export const reservationInvoicePanel = {
  loadingVerifying: "Weryfikowanie…",

  status: {
    draft: "Szkic",
    sent: "Wystawiona",
    processing: "Przetwarzanie",
    pending: "Oczekuje",
    error: "Błąd",
    corrected: "Skorygowana",
    voided: "Anulowana",
  },

  common: {
    cancel: "Anuluj",
    understood: "Rozumiem",
    optional: "opcjonalnie",
    optionalParen: "(opcjonalnie)",
    sending: "Wysyłanie…",
    saving: "Zapisywanie…",
    deleting: "Usuwanie…",
    emitting: "Wystawianie…",
    creating: "Tworzenie…",
    retrying: "Ponawianie…",
  },

  issued: {
    title: "Wystawione faktury",
    rectifOf: "Korekta do {code}",
    viewPdf: "Zobacz PDF",
    sendByWhatsapp: "Wyślij przez WhatsApp",
    correctTitle: "Skoryguj (faktura korygująca)",
    voidTitle: "Anuluj (faktura korygująca)",
  },

  empty: {
    guestRequested: "Gość poprosił o fakturę",
    noInvoice: "Nie wystawiono faktury",
    linkSent: "Link wysłany",
    requested: "Poproszono",
    requestedSub: "Sprawdź dane gościa i wystaw fakturę albo wyślij mu link do potwierdzenia.",
    sub: "Wyślij link gościowi albo utwórz fakturę bezpośrednio.",
    copyLinkTitle: "Skopiuj link do schowka",
    sendLink: "Wyślij link",
    createInvoice: "Utwórz fakturę",
    configureHint: "Uzupełnij dane do faktur, aby włączyć tę funkcję.",
  },

  next: {
    title: "Ta rezerwacja ma już swoją fakturę",
    sub: "Pojawiła się późniejsza opłata? Utwórz kolejną fakturę do tej rezerwacji: obejmie tylko nowe opłaty (zafakturowany już nocleg nie jest powtarzany).",
    button: "Utwórz kolejną fakturę do tej rezerwacji",
  },

  card: {
    draftRefTitle: "Wewnętrzny numer szkicu. Numer podatkowy nadawany jest przy wystawieniu.",
  },

  draft: {
    emptyHint: 'Dodaj co najmniej jedną opłatę w sekcji <b>„Nowe opłaty”</b>, aby wystawić tę fakturę.',
    noteLead: "Szkic: zmień dane albo dodaj opłaty powyżej; numer i data są nadawane przy <b>wystawieniu</b>.",
    nextSequential: "Następny numer kolejny",
    estimated: "orientacyjnie",
    noteFoot: "Numer nie jest ostateczny: weźmie go pierwsza wystawiona faktura.",
    confirmEmit: "Potwierdź i wystaw fakturę",
    previewPdf: "Podgląd PDF",
    sendQuote: "Wyślij wycenę",
    edit: "Edytuj fakturę",
    discard: "Odrzuć",
  },

  // Pozycje wystawianego dokumentu: to, co sprawdza się PRZED wystawieniem.
  concepts: {
    title: "Pozycje dokumentu",
    item: "Pozycja",
    qty: "Ilość",
    unitPrice: "Cena jedn.",
    vat: "VAT",
    amount: "Kwota",
    linesTotal: "Suma pozycji",
    foot: "Tak będzie wyglądać rozbicie na fakturze. PDF zawiera pełny szczegół.",
    mismatch: "Suma pozycji ({lines}) nie zgadza się z sumą dokumentu ({total}). Sprawdź to przed wystawieniem.",
  },

  // Lo cobrado y lo que queda a deber. Mismas palabras y mismo orden que el
  // pie del PDF, para que leer la pantalla y leer la factura sea lo mismo.
  cobro: {
    total: "Suma dokumentu",
    nothing: "Brak zarejestrowanych wpłat",
    due: "Do zapłaty",
    assumed: "Przy tej rezerwacji nie zarejestrowano żadnej wpłaty. Kwota jest uznawana za opłaconą na podstawie wybranej formy płatności i tak samo pojawi się w PDF. Jeśli jeszcze nie otrzymałeś zapłaty, zarejestruj wpłatę lub zmień formę płatności.",
  },

  actions: {
    sendWhatsapp: "Wyślij WhatsApp",
    correct: "Skoryguj",
    void: "Anuluj",
    refresh: "Odśwież",
    retry: "Ponów",
    editData: "Edytuj dane",
    delete: "Usuń",
  },

  wa: {
    title: "Wyślij fakturę przez WhatsApp",
    desc: "Faktura <strong>{code}</strong> zostanie wysłana gościowi w PDF przez WhatsApp.",
    issuedFallback: "wystawiona",
    checkPhone: "Zostanie użyty telefon gościa powiązany z rezerwacją",
    checkPdf: "Dokument zostanie wysłany w PDF",
    send: "Wyślij fakturę",
  },

  sendLink: {
    title: "Wyślij link do faktury",
    desc: "Gość otrzyma <strong>link przez WhatsApp</strong>, aby potwierdzić swoje dane podatkowe i pobrać fakturę.",
    checkNoInvoice: "Faktura nie jest jeszcze wystawiona: gość dostaje tylko link",
    button: "Wyślij link",
  },

  retryModal: {
    title: "Ponów wystawienie",
    desc: "Spróbujemy ponownie <strong>wystawić tę fakturę</strong> z obecnymi danymi.",
    check1: "Zostanie ponownie wysłana do organu ds. e-faktur",
    check2: "Jeśli się uda, nadany zostanie ostateczny numer podatkowy",
  },

  voidModal: {
    doneTitle: "Faktura anulowana · wystawiono fakturę korygującą",
    creditNoteIssued: "Wystawiono fakturę korygującą <strong>{code}</strong>",
    chargesReleased: "Opłaty dodatkowe zostały zwolnione",
    clientCanRequest: "Klient może ponownie poprosić o fakturę",
    doneHint: "Dodaj lub popraw oczekujące opłaty i utwórz nową fakturę.",
    formTitle: "Anuluj fakturę / wystaw fakturę korygującą",
    formDesc: "Skorzystaj z tej opcji, gdy trzeba <strong>dodać lub zmienić usługi albo kwoty</strong>. Zostanie wystawiona <strong>faktura korygująca</strong>, która anuluje pierwotną fakturę, a następnie będzie można utworzyć nową fakturę z prawidłowymi opłatami.",
    stepAnnul: "Zostaje wystawiona faktura korygująca, która anuluje {code}",
    stepFree: "Opłaty zostają zwolnione do dodania lub poprawienia",
    stepNewNumber: "Powstaje nowa faktura z kolejnym numerem",
    notice: "Aby poprawić wyłącznie NIF, nazwę lub adres bez zmiany kwot, użyj zamiast tego opcji <strong>Skoryguj dane</strong>.",
    voiding: "Wystawianie faktury korygującej…",
    confirm: "Anuluj i wystaw fakturę korygującą",
  },

  edit: {
    titleDraft: "Edytuj fakturę",
    titleClient: "Edytuj dane klienta",
    descDraft: "Zmiany zapisują się natychmiast. Dane podatkowe są sprawdzane bez wystawiania faktury.",
    descSent: "Po zapisaniu wysyłka zostanie automatycznie ponowiona.",
    type: "Rodzaj",
    individual: "Osoba prywatna",
    individualSub: "Osoba fizyczna",
    company: "Firma",
    companySub: "Osoba prawna",
    legalName: "Nazwa firmy",
    fullName: "Imię i nazwisko",
    legalNamePlaceholder: "Pełna nazwa firmy",
    fullNamePlaceholder: "Imię i nazwisko",
    country: "Kraj",
    countryPlaceholder: "Wybierz kraj gościa",
    taxRequiredOnEmit: "wymagane przy wystawieniu",
    taxIdPlaceholderCompany: "NIF / CIF firmy",
    taxIdPlaceholderIndividual: "DNI / NIE · puste = konsument końcowy",
    email: "E-mail",
    emailPlaceholder: "email@example.com",
    phone: "Telefon",
    phonePlaceholder: "+34 600 000 000",
    fiscalAddress: "Adres do faktury",
    addressPlaceholder: "Ulica i numer",
    city: "Miasto",
    region: "Region / województwo",
    zip: "Kod pocztowy",
    saveChanges: "Zapisz zmiany",
    saveAndRetry: "Zapisz i ponów",
  },

  deleteModal: {
    title: "Usuń fakturę",
    desc: "Ta próba wystawienia faktury zostanie usunięta. Klient będzie mógł ponownie poprosić o fakturę od zera.",
    noticeIrreversible: "Tej operacji nie da się cofnąć.",
  },

  emit: {
    title: "Potwierdź i wystaw fakturę",
    subtitle: "Zostaje oficjalnie zarejestrowana",
    desc: "Za chwilę wystawisz fakturę dla: {name}.",
    stepNumberEstimate: "Zostaje nadany numer kolejny <b>{code}</b>; weźmie go pierwsza wystawiona faktura.",
    stepNumberFinal: "Zostaje nadany <b>ostateczny</b> numer kolejny; weźmie go pierwsza wystawiona faktura.",
    stepPdf: "Powstaje podatkowy PDF, który trafia do organu podatkowego.",
    warn: "Po wystawieniu faktury <b>nie da się jej edytować</b>. W razie błędu trzeba będzie <b>anulować ją i utworzyć nową</b> (notą kredytową lub korygującą).",
    confirm: "Potwierdź i wystaw",
  },

  newInvoice: {
    title: "Utwórz kolejną fakturę",
    subtitle: "Do tej samej rezerwacji",
    desc: "Otworzy się <strong>nowy szkic</strong> do tej rezerwacji.",
    step1: "Obejmie <b>tylko nowe opłaty</b>, które dodasz; zafakturowany już nocleg nie jest powtarzany.",
    step2: "Przejmie dane tego samego klienta. Numer nadawany jest przy wystawieniu.",
    createDraft: "Utwórz szkic",

    // Facturar toda la reserva o una sola habitación (reservas de varias).
    scopeTitle: "Jak chcesz fakturować?",
    whole: "Cała rezerwacja",
    wholeHint: "Jedna faktura obejmująca {n} pokoi.",
    perRoom: "Jeden pokój",
    perRoomHint: "Każdy pokój ma swoją fakturę. Gdy każdy gość płaci za siebie.",
    pickRoom: "Wybierz pokój",
    roomLodging: "Zakwaterowanie",
    alreadyInvoiced: "już zafakturowany",
  },

  correction: {
    doneTitle: "Wystawiono fakturę korygującą",
    createdOk: "Utworzono korektę <strong>{code}</strong>",
    originalKept: "Pierwotna faktura pozostaje jako odniesienie podatkowe (nie jest usuwana)",
    pdfSoon: "PDF zostanie wygenerowany za chwilę",
    title: "Skoryguj fakturę",
    infobox: "Zostanie wystawiona <strong>korygująca faktura korygująca</strong>, która podatkowo zastępuje <strong>{code}</strong> i obejmuje aktualne opłaty rezerwacji. Pierwotnego numeru nie da się zmienić (tak stanowi prawo).",
    reasonLabel: "Powód korekty",
    selectReason: "Wybierz powód",
    reasonTaxId: "Błędny NIF / CIF lub numer podatkowy",
    reasonName: "Błędne imię, nazwisko lub nazwa firmy",
    reasonAddress: "Błędny adres do faktury",
    reasonEmail: "Błędny adres e-mail",
    reasonGeneral: "Ogólna korekta danych podatkowych",
    reasonOther: "Inny (wpisz powód)",
    customReasonPlaceholder: "Opisz powód korekty…",
    recipientDivider: "Dane odbiorcy: zmień tylko to, co wymaga korekty",
    nameOrLegalName: "Imię i nazwisko / nazwa firmy",
    taxIdFull: "NIF / CIF / numer podatkowy / paszport",
    countryTwoLetters: "(2 litery)",
    paymentDivider: "Sposób płatności",
    paymentLabel: "Rodzaj płatności",
    paymentUnspecified: "Nie określono",
    paymentCash: "Gotówka",
    paymentCard: "Karta kredytowa lub debetowa",
    paymentTransfer: "Przelew bankowy",
    paymentStripe: "Stripe (online)",
    emitRectif: "Wystaw korektę",
  },

  request: {
    typeCompany: "Firma",
    typeIndividual: "Osoba prywatna",
    type: "Rodzaj",
    legalName: "Nazwa firmy / imię i nazwisko",
    taxId: "NIF / CIF",
    address: "Adres",
    postalCode: "Kod pocztowy",
    city: "Miasto",
    state: "Województwo",
    country: "Kraj",
    email: "E-mail",
  },

  toast: {
    linkSent: "Link do faktury został wysłany gościowi przez WhatsApp.",
    alreadyIssued: "Ta rezerwacja ma już wystawioną fakturę.",
    cantSendLink: "Nie udało się wysłać linku.",
    linkCopied: "Link skopiowany do schowka.",
    alreadyHasInvoice: "Ta rezerwacja ma już fakturę.",
    cantGenerateLink: "Nie udało się wygenerować linku.",
    cantSendWhatsapp: "Nie udało się wysłać przez WhatsApp.",
    invoiceSentWhatsapp: "Faktura wysłana przez WhatsApp.",
    draftCreatedNewCharges: "Utworzono szkic z nowymi opłatami (bez powtarzania noclegu). Sprawdź go i wystaw.",
    draftCreated: "Szkic utworzony. Dodaj opłaty i wystaw fakturę, gdy będzie gotowa.",
    alreadyInProgress: "Ta rezerwacja ma już fakturę w trakcie przygotowania.",
    cantCreateDraft: "Nie udało się utworzyć szkicu.",
    invoiceEmitted: "Faktura wystawiona. Trwa generowanie numeru i PDF…",
    cantEmit: "Nie udało się wystawić faktury.",
    cantPreview: "Nie udało się wygenerować podglądu.",
    quoteSent: "Wycena wysłana na {email}",
    cantSendQuote: "Nie udało się wysłać wyceny",
    cantSync: "Nie udało się zsynchronizować statusu.",
    retrying: "Ponawianie wystawienia…",
    cantRetry: "Nie udało się ponowić.",
    cantVoid: "Błąd przy anulowaniu faktury.",
    savedCheckFiscal: "Zapisano. Sprawdź dokument podatkowy.",
    dataUpdated: "Dane zaktualizowane.",
    cantSaveData: "Nie udało się zapisać danych.",
    invoiceDeleted: "Faktura usunięta.",
    cantDelete: "Nie udało się usunąć.",
    cantEmitRectif: "Błąd przy wystawianiu korekty.",
  },
};
